import { render } from "./verifyemail.vue?vue&type=template&id=87896e30"
import script from "./verifyemail.vue?vue&type=script&lang=js"
export * from "./verifyemail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__